import { AxiosError } from "axios";
import { useTokenStore } from "core/features/auth/hooks/useTokenStore";
import { api } from "infra/axios";
import { showError } from "infra/packages/helpers/alerta";
import { useMutation } from "react-query";
import { useNavigate, } from "react-router-dom";
import { useIngressosStore } from "ui/pages/Admin/Ingresso/hooks/useIngressosStore";
import { ValidationDetails } from "./useComprarIngressoCC";

interface Address {
  cep: string;
  nome: string;
  complemento?: string;
  cepId: number;
  cidadeId: number;
  nomeBairro: string;
  nomeEstado: string;
  nomeCidade: string;
  logradouro: string;
  bairroId: number;
  pais: string;
  numero: string;
}

function useComprarIngresso() {
  const url = `v2/ingressos/comprar`;
  const token = useTokenStore((state) => state?.token?.access_token);
  const diaUtil = useIngressosStore((state) => state?.diaUtilSelecionado);
  const eventoId = useIngressosStore((state) => state.eventoId);
  const calendarioId = useIngressosStore((state) => state.calendarioId);
  const navigate = useNavigate();

  return useMutation(
    async (dadosEndereco?: Address) => {
      const ingressos =
        useIngressosStore
          .getState()
          .ingressos?.filter((ingresso) => ingresso.quantity > 0) ?? [];

      const valorTotal = Object.entries(ingressos).reduce((acc, curr) => {
        const [, value] = curr;
        const taxa = value.item?.valorTaxaWeb || 0;
        return (
          acc +
          value.quantity *
          (value.item.valorBase + taxa + value.item.valorServico)
        );
      }, 0);

      const totalServico = Object.entries(ingressos).reduce((acc, curr) => {
        const [, value] = curr;

        return acc + value.item.valorServico;
      }, 0);

      const subTotal = Object.entries(ingressos).reduce((acc, curr) => {
        const [, value] = curr;
        return acc + value.quantity * value.item.valorBase;
      }, 0);

      const { data } = await api.post(
        url,
        {
          tagCrm: localStorage.getItem("tag_crm") ?? "",
          modalidadeCaixaApiId: 101,
          endereco: dadosEndereco,
          ingressoEventoId: eventoId,
          calendarioId: diaUtil?.calendarioId,
          valorTotal,
          valorIngresso: subTotal,
          valorTaxa: 0,
          valorServico: totalServico,
          ingressosVendaItem: ingressos?.map((ingresso) => ({
            qtde: ingresso.quantity,
            valorUnitario: ingresso.item.valorBase + ingresso.item.valorTaxaWeb,
            ingressoSetorId: ingresso.item.ingressoSetorId,
            ingressoSetorOpcaoId: ingresso.item.id,
            valorIngresso:
              (ingresso.item.valorBase + ingresso.item.valorTaxaWeb) *
              ingresso.quantity,
            valorServico: ingresso.item.valorServico,
            valorTaxa: ingresso.item.valorTaxaWeb,
            valorTotal:
              (ingresso.item.valorBase +
                ingresso.item.valorTaxaWeb +
                ingresso.item.valorServico) *
              ingresso.quantity,
            utilizadorNome: "",
            utilizadorDocumento: "",
          })),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    },
    {
      onError: (error: AxiosError<ValidationDetails>) => {
        error.response?.data.details.forEach((detail) => {
          detail.errors.forEach((error) => {
            showError(error);
          });
        });
      },
      onSuccess(data) {
        useIngressosStore?.getState().setPixData(data);
        navigate(`/ingresso/${calendarioId}/confirmacao/pix`);
      },
    }
  );
}

export default useComprarIngresso;
